module.exports = __webpack_public_path__ + "img/appltCourse-img1.5873c69d.png";